import React, { useState, useEffect, useRef } from 'react';
import styles from '../../pages/CustomJob/PostJob.module.scss';
import saveIcon from "../../assets/images/saveIcon.png";
import addIcon from "../../assets/images/add.svg";
import removeIcon from "../../assets/images/reduce-icon.svg";
import downArrow from "../../assets/images/downArrow.png";
import indianFlag from "../../assets/images/indianFlag.PNG";
import whatsappIcon from "../../assets/images/whatsapp.png";
// import mobVerified from "../../assets/images/mob-verified.png";
// import locationIcon from "../../assets/images/location_icon.png";
import searchIcon from "../../assets/images/search_icon.png";

// Range Slider Component
const RangeSlider = ({ min, max, from, to, step, onChange }) => {
  const [minVal, setMinVal] = useState(from);
  const [maxVal, setMaxVal] = useState(to);

  useEffect(() => {
    setMinVal(from);
    setMaxVal(to);
  }, [from, to]);

  const handleMinChange = (e) => {
    const value = Math.min(parseInt(e.target.value), maxVal - step);
    setMinVal(value);
    onChange({ from: value, to: maxVal });
  };

  const handleMaxChange = (e) => {
    const value = Math.max(parseInt(e.target.value), minVal + step);
    setMaxVal(value);
    onChange({ from: minVal, to: value });
  };

  const minPercent = ((minVal - min) / (max - min)) * 100;
  const maxPercent = ((maxVal - min) / (max - min)) * 100;

  return (
    <div className={styles['range-slider-container']}>
      <div className={styles['slider-track']}></div>
      <div 
        className={styles['slider-range']} 
        style={{ left: `${minPercent}%`, right: `${100 - maxPercent}%` }}
      ></div>
      <input
        type="range"
        min={min}
        max={max}
        value={minVal}
        step={step}
        onChange={handleMinChange}
        className={`${styles.slider} ${styles['slider-min']}`}
      />
      <input
        type="range"
        min={min}
        max={max}
        value={maxVal}
        step={step}
        onChange={handleMaxChange}
        className={`${styles.slider} ${styles['slider-max']}`}
      />
    </div>
  );
};

const PostJobUpdate = ({ jobId, onClose,onSuccess}) => {
  // API Base URLs
  const API_BASE_URL = 'https://prod.java.taizo.in/webEmployer';
  const ADMIN_API_BASE_URL = 'https://prod.java.taizo.in/admin';

  // URL Parameters (keep these for other params)
  const urlParams = new URLSearchParams(window.location.search);
  const draftJobId = urlParams.get('draftJob_id');
  const savedJobId = urlParams.get('savedJob_id');
  const repostId = urlParams.get('repostJob_id');

  // State variables
  const [employerId, setEmployerId] = useState('');
  const [jobRoleCategory, setJobRoleCategory] = useState('');
  const [jobRole, setJobRole] = useState('');
  const [noOfOpenings, setNoOfOpenings] = useState('');
  const [male, setMale] = useState(0);
  const [female, setFemale] = useState(0);
  const [jobDescription, setJobDescription] = useState('');
  const [jobDescriptionLink, setJobDescriptionLink] = useState('');
  const [minSalary, setMinSalary] = useState('14000');
  const [maxSalary, setMaxSalary] = useState('20000');
  const [minExp, setMinExp] = useState('');
  
  // Key Skills State - FIXED
  const [keySkills, setKeySkills] = useState([]); // For display
  const [ksValueArr, setKsValueArr] = useState([]); // For API submission
  const [selectedKeySkill, setSelectedKeySkill] = useState([]); // For UI tracking with IDs
  const [filteredKeySkills, setFilteredKeySkills] = useState([]);
  const [keySkillSearchTerm, setKeySkillSearchTerm] = useState('');
  
  // Education State
  const [educationQualification, setEducationQualification] = useState([]);
  const [eqValueArr, setEqValueArr] = useState([]);
  
  // Benefits State
  const [benefits, setBenefits] = useState([]);
  const [benefitsText, setBenefitsText] = useState([]);
  
  // Additional Details State
  const [shiftType, setShiftType] = useState('');
  const [otType, setOtType] = useState('');
  const [workHours, setWorkHours] = useState('');
  const [locationUrl, setLocationUrl] = useState('');
  const [contactPersonName, setContactPersonName] = useState('');
  const [contactNum, setContactNum] = useState('');
  const [alternateNum, setAlternateNum] = useState('');
  const [whatAppNumber, setWhatAppNumber] = useState('');
  const [companyName, setCompanyName] = useState('');
  const [cityName, setCityName] = useState('');
  const [areaName, setAreaName] = useState('');
  const [addressText, setAddressText] = useState('');
  const [latitude, setLatitude] = useState('');
  const [longitude, setLongitude] = useState('');
  const [state, setState] = useState('');
  const [country, setCountry] = useState('');
  const [pincode, setPincode] = useState('');
  const [whatsappNoti, setWhatsappNoti] = useState(true);
  
  // UI State
  const [showAlternateNum, setShowAlternateNum] = useState(false);
  const [showAddDetails, setShowAddDetails] = useState(true);
  const [showKeySkillsPopup, setShowKeySkillsPopup] = useState(false);
  const [showEduQualityPopup, setShowEduQualityPopup] = useState(false);
  const [showJobRoleModal, setShowJobRoleModal] = useState(false);
  const [selectedJobRole, setSelectedJobRole] = useState('');
  const [showSalaryModal, setShowSalaryModal] = useState(false);
  const [showBenefitsModal, setShowBenefitsModal] = useState(false);
  const [showSavePopup, setShowSavePopup] = useState(false);
  const [showWhatsAppAlert, setShowWhatsAppAlert] = useState(false);
  const [showOtpPopup, setShowOtpPopup] = useState(false);
  const [showPricingPopup, setShowPricingPopup] = useState(false);
  const [showLocationPopup, setShowLocationPopup] = useState(false);
  const [showFrequentlyPopup, setShowFrequentlyPopup] = useState(false);
  const [otpFor, setOtpFor] = useState('');
  
  // Data state
  const [industries, setIndustries] = useState([]);
  const [jobRoles, setJobRoles] = useState([]);
  const [keySkillsList, setKeySkillsList] = useState([]);
  const [keyskillsAutocompleteArr, setKeyskillsAutocompleteArr] = useState([]);
  const [benefitsList, setBenefitsList] = useState([]);
  const [filteredJobRoles, setFilteredJobRoles] = useState([]);
  const [cities, setCities] = useState([]);
  const [areas, setAreas] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedIndustry, setSelectedIndustry] = useState(null);
  const [salaryRange, setSalaryRange] = useState({ from: 14000, to: 20000 });
  const [fileName, setFileName] = useState('No file chosen');
  const [loading, setLoading] = useState(false);
  const [otpLoading, setOtpLoading] = useState(false);
  const [noError, setNoError] = useState(0);
  const [errFieldsArr, setErrFieldsArr] = useState([]);
  
  // Error state
  const [errors, setErrors] = useState({});
  
  // OTP state
  const [otpValues, setOtpValues] = useState(['', '', '', '', '', '']);
  const [otpVerified, setOtpVerified] = useState(false);
  const [showOtpError, setShowOtpError] = useState(false);
  const [otpTimer, setOtpTimer] = useState(0);
  const otpInputsRef = useRef([]);
  
  // User location details
  const [userLocationDetails, setUserLocationDetails] = useState({
    latitude: null,
    longitude: null,
    state: null,
    pin_code: null,
    country: null,
    area: null
  });

  // Refs
  const fileInputRef = useRef(null);
  const jobRoleSearchRef = useRef(null);
  const keyskillsSearchRef = useRef(null);
  const companyNameInputRef = useRef(null);
  const autocompleteRef = useRef(null);

  // Fetch initial data
  useEffect(() => {
    fetchIndustries();
    fetchKeySkills();
    fetchBenefits();
    fetchCities();
    
    // Use the jobId prop instead of URL parameter
    if (jobId) {
      getJobDetails(jobId);
    } else if (savedJobId) {
      getSavedJobDetails(savedJobId);
    } else if (repostId) {
      getSavedJobDetails(repostId);
    } else if (draftJobId) {
      getDraftJobDetails(draftJobId);
    } else {
      initializeRangeSlider();
    }
  }, [jobId]);

  // Initialize Google Places Autocomplete
  useEffect(() => {
    if (window.google && companyNameInputRef.current) {
      initAutocomplete();
    }
  }, [companyNameInputRef.current]);

  // OTP Timer
  useEffect(() => {
    let interval;
    if (otpTimer > 0) {
      interval = setInterval(() => {
        setOtpTimer(prev => prev - 1);
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [otpTimer]);

  // Initialize Range Slider
  const initializeRangeSlider = () => {
    setSalaryRange({ from: 14000, to: 20000 });
  };

  // Initialize Google Places Autocomplete
  const initAutocomplete = () => {
    if (!window.google) return;
    
    const input = companyNameInputRef.current;
    const autocomplete = new window.google.maps.places.Autocomplete(input);
    
    autocomplete.addListener('place_changed', () => {
      const place = autocomplete.getPlace();
      
      if (place.geometry) {
        const lat = place.geometry.location.lat();
        const lng = place.geometry.location.lng();
        
        setLatitude(lat);
        setLongitude(lng);
        setAddressText(place.formatted_address || '');
        setCompanyName(place.name || '');
        
        let city = '', state = '', country = '', pincode = '', area = '';
        
        place.address_components.forEach(component => {
          const types = component.types;
          
          if (types.includes('locality')) {
            city = component.long_name;
          } else if (types.includes('administrative_area_level_1')) {
            state = component.long_name;
          } else if (types.includes('postal_code')) {
            pincode = component.long_name;
          } else if (types.includes('country')) {
            country = component.long_name;
          } else if (types.includes('sublocality_level_1')) {
            area = component.long_name;
          }
        });
        
        setCityName(city);
        setState(state);
        setCountry(country);
        setPincode(pincode);
        setAreaName(area);
        
        setUserLocationDetails({
          latitude: lat,
          longitude: lng,
          state: state,
          pin_code: pincode,
          country: country,
          area: area
        });
        
        removeError('addressText');
        removeError('companyName');
        removeError('cityName');
      }
    });
  };

  // API Functions
  const fetchIndustries = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/jobIndustries`);
      const data = await response.json();
      if (data?.data) {
        setIndustries(data.data);
      }
    } catch (error) {
      console.error('Error fetching industries:', error);
    }
  };

  const fetchJobRoles = async (industryId) => {
    setLoading(true);
    try {
      const response = await fetch(`${API_BASE_URL}/fullTimeJobRoles?industry_id=${industryId}`);
      const data = await response.json();
      if (data?.data) {
        setJobRoles(data.data);
        setFilteredJobRoles(data.data);
        if (jobRoleSearchRef.current) {
          jobRoleSearchRef.current.value = '';
        }
      }
    } catch (error) {
      console.error('Error fetching job roles:', error);
    } finally {
      setLoading(false);
    }
  };

  const fetchKeySkills = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/keySkills`);
      const data = await response.json();
      if (data?.data) {
        setKeySkillsList(data.data);
        const autocompleteArr = data.data.map(item => item.skill);
        setKeyskillsAutocompleteArr(autocompleteArr);
      }
    } catch (error) {
      console.error('Error fetching key skills:', error);
    }
  };

  const fetchBenefits = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/benefits`);
      const data = await response.json();
      if (data?.data) {
        setBenefitsList(data.data);
      }
    } catch (error) {
      console.error('Error fetching benefits:', error);
    }
  };

  const fetchCities = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/cities?state_id=0`);
      const data = await response.json();
      if (data?.data) {
        setCities(data.data);
      }
    } catch (error) {
      console.error('Error fetching cities:', error);
    }
  };

  const fetchAreas = async (cityId) => {
    try {
      const response = await fetch(`${API_BASE_URL}/areas?city_id=${cityId}`);
      const data = await response.json();
      if (data?.data) {
        setAreas(data.data);
      }
    } catch (error) {
      console.error('Error fetching areas:', error);
    }
  };

  const getJobDetails = async (id) => {
    setLoading(true);
    try {
      const response = await fetch(`${API_BASE_URL}/job/${id}`);
      const data = await response.json();
      if (data?.jobDetails) {
        populateJobForm(data.jobDetails);
      }
    } catch (error) {
      console.error('Error fetching job details:', error);
    } finally {
      setLoading(false);
    }
  };

  const getSavedJobDetails = async (id) => {
    setLoading(true);
    try {
      const response = await fetch(`${API_BASE_URL}/job/${id}`);
      const data = await response.json();
      if (data?.jobDetails) {
        populateJobForm(data.jobDetails);
      }
    } catch (error) {
      console.error('Error fetching saved job:', error);
    } finally {
      setLoading(false);
    }
  };

  const getDraftJobDetails = async (id) => {
    setLoading(true);
    try {
      const response = await fetch(`${API_BASE_URL}/draftJob/${id}`);
      const data = await response.json();
      if (data) {
        setJobRoleCategory(data.jobCategory || '');
        setJobRole(data.jobIndustry || '');
        setNoOfOpenings(data.noOfOpenings || '');
      }
    } catch (error) {
      console.error('Error fetching draft job:', error);
    } finally {
      setLoading(false);
    }
  };

  const populateJobForm = (jobData) => {
    setEmployerId(jobData.employerId || '');
    setJobRoleCategory(jobData.jobCategory || '');
    setJobRole(jobData.industry || '');
    setNoOfOpenings(jobData.noOfOpenings?.toString() || '');
    setMale(jobData.male || 0);
    setFemale(jobData.female || 0);
    setMinSalary(jobData.salary?.toString() || '14000');
    setMaxSalary(jobData.maxSalary?.toString() || '20000');
    setContactPersonName(jobData.contactPersonName || '');
    setLocationUrl(jobData.companyLocationUrl || '');
    setContactNum(jobData.mobileNumber || '');
    setWhatAppNumber(jobData.whatsappNumber || '');
    setCompanyName(jobData.companyName || '');
    setCityName(jobData.jobLocation || '');
    setAreaName(jobData.area || '');
    setAddressText(jobData.jobLocationAddr || '');
    setLatitude(jobData.jobLatitude || '');
    setLongitude(jobData.jobLongitude || '');
    setState(jobData.state || '');
    setCountry(jobData.jobCountry || '');
    setJobDescription(jobData.jobDescription || '');
    setJobDescriptionLink(jobData.jobDescriptionLink || '');
    setWhatsappNoti(jobData.whatsappNoti !== false);
    
    if (jobData.alternateMobileNumber) {
      setShowAlternateNum(true);
      setAlternateNum(jobData.alternateMobileNumber);
    }
    
    // Set experience
    if (jobData.jobExp === '0' && jobData.jobMaxExp === '0') {
      setMinExp('Freshers');
    } else if (jobData.jobExp === '0' && jobData.jobMaxExp === '1') {
      setMinExp('0 - 1');
    } else {
      setMinExp(jobData.jobExp || '');
    }
    
    // Set key skills - FIXED
    if (jobData.keyskills) {
      const skills = jobData.keyskills.split(', ');
      setKeySkills(skills);
      setKsValueArr(skills);
      
      // Map to selectedKeySkill format with IDs
      // We need to wait for keySkillsList to be populated
      if (keySkillsList.length > 0) {
        const selectedWithIds = [];
        keySkillsList.forEach((skill, index) => {
          if (skills.includes(skill.skill)) {
            selectedWithIds.push(`${skill.skill}/${index}_ks`);
          }
        });
        setSelectedKeySkill(selectedWithIds);
      }
    }
    
    // Set education
    if (jobData.qualification) {
      const quals = jobData.qualification.split(', ');
      setEducationQualification(quals);
      setEqValueArr(quals);
    }
    
    // Set benefits
    if (jobData.benefits) {
      const benefitsArr = jobData.benefits.split(', ');
      setBenefits(benefitsArr);
      setBenefitsText(benefitsArr);
    }
    
    // Set additional details
    if (jobData.additionalDetailsFilled) {
      setShowAddDetails(true);
      setShiftType(jobData.shiftType || '');
      setOtType(jobData.ot || '');
      setWorkHours(jobData.workHours || '');
    }
    
    // Set salary range
    setSalaryRange({
      from: jobData.salary || 14000,
      to: jobData.maxSalary || 20000
    });
    
    // Remove errors after population
    removeError('jobRoleCategory');
    removeError('keySkill_input');
    removeError('edu_quality_error');
    removeError('benefits_text_area');
    removeError('minSalary');
    removeError('maxSalary');
    removeError('minExp');
    removeError('contactNum');
    removeError('contactPersonName');
  };

  // Update selectedKeySkill when keySkillsList is loaded
  useEffect(() => {
    if (keySkillsList.length > 0 && keySkills.length > 0) {
      const selectedWithIds = [];
      keySkillsList.forEach((skill, index) => {
        if (keySkills.includes(skill.skill)) {
          selectedWithIds.push(`${skill.skill}/${index}_ks`);
        }
      });
      setSelectedKeySkill(selectedWithIds);
    }
  }, [keySkillsList]);

  // OTP Functions
  const sendOtp = async (number, type) => {
    if (!number || number.length !== 10) {
      alert('Please enter a valid 10-digit number');
      return;
    }

    setOtpLoading(true);
    setOtpFor(type);
    
    try {
      const response = await fetch(`${API_BASE_URL}/sendOtp`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ mobileNumber: number })
      });
      
      const data = await response.json();
      if (data.status) {
        setShowOtpPopup(true);
        setOtpValues(['', '', '', '', '', '']);
        setOtpTimer(60);
        setShowOtpError(false);
      } else {
        alert('Failed to send OTP. Please try again.');
      }
    } catch (error) {
      console.error('Error sending OTP:', error);
      alert('Error sending OTP. Please try again.');
    } finally {
      setOtpLoading(false);
    }
  };

  const verifyOtp = async (e) => {
    e.preventDefault();
    const otp = otpValues.join('');
    
    if (otp.length !== 6) {
      setShowOtpError(true);
      return;
    }

    setOtpLoading(true);
    const number = otpFor === 'alternate' ? alternateNum : contactNum;

    try {
      const response = await fetch(`${API_BASE_URL}/verifyOtp`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ mobileNumber: number, otp })
      });
      
      const data = await response.json();
      if (data.status) {
        setOtpVerified(true);
        setTimeout(() => {
          setShowOtpPopup(false);
          setOtpValues(['', '', '', '', '', '']);
          setOtpVerified(false);
        }, 2000);
      } else {
        setShowOtpError(true);
      }
    } catch (error) {
      console.error('Error verifying OTP:', error);
      setShowOtpError(true);
    } finally {
      setOtpLoading(false);
    }
  };

  const resendOtp = async (e) => {
    e.preventDefault();
    const number = otpFor === 'alternate' ? alternateNum : contactNum;
    await sendOtp(number, otpFor);
  };

  // Handlers
  const handleMaleIncrease = () => {
    setMale(prev => prev + 1);
    removeError('gender');
  };
  
  const handleMaleDecrease = () => {
    setMale(prev => Math.max(0, prev - 1));
    removeError('gender');
  };
  
  const handleFemaleIncrease = () => {
    setFemale(prev => prev + 1);
    removeError('gender');
  };
  
  const handleFemaleDecrease = () => {
    setFemale(prev => Math.max(0, prev - 1));
    removeError('gender');
  };

  // FIXED: Key Skills Toggle Handler
  const handleKeySkillToggle = (skill, index) => {
    const skillId = `${index}_ks`;
    const skillWithId = `${skill}/${skillId}`;
    
    // Update keySkills array for display
    setKeySkills(prev => {
      if (prev.includes(skill)) {
        return prev.filter(s => s !== skill);
      } else if (prev.length < 5) {
        return [...prev, skill];
      }
      return prev;
    });
    
    // Update ksValueArr for API submission
    setKsValueArr(prev => {
      if (prev.includes(skill)) {
        return prev.filter(s => s !== skill);
      } else if (prev.length < 5) {
        return [...prev, skill];
      }
      return prev;
    });
    
    // Update selectedKeySkill for UI tracking
    setSelectedKeySkill(prev => {
      if (prev.includes(skillWithId)) {
        return prev.filter(item => item !== skillWithId);
      } else if (prev.length < 5) {
        return [...prev, skillWithId];
      }
      return prev;
    });
    
    removeError('keySkills');
  };

  const handleEducationToggle = (qual) => {
    setEducationQualification(prev => {
      if (prev.includes(qual)) {
        return prev.filter(q => q !== qual);
      } else {
        return [...prev, qual];
      }
    });
    
    setEqValueArr(prev => {
      if (prev.includes(qual)) {
        return prev.filter(q => q !== qual);
      } else {
        return [...prev, qual];
      }
    });
    
    removeError('education');
  };

  const handleBenefitToggle = (benefit) => {
    setBenefits(prev => {
      if (prev.includes(benefit)) {
        return prev.filter(b => b !== benefit);
      } else if (prev.length < 10) {
        return [...prev, benefit];
      }
      return prev;
    });
    
    setBenefitsText(prev => {
      if (prev.includes(benefit)) {
        return prev.filter(b => b !== benefit);
      } else if (prev.length < 10) {
        return [...prev, benefit];
      }
      return prev;
    });
    
    removeError('benefits');
  };

  const handleFileChange = (e) => {
    if (e.target.files[0]) {
      setSelectedFile(e.target.files[0]);
      setFileName(e.target.files[0].name);
    }
  };

  const handleJobRoleSearch = (e) => {
    const search = e.target.value.toLowerCase();
    
    if (search.trim() === '') {
      setFilteredJobRoles(jobRoles);
    } else {
      const filtered = jobRoles.filter(role => 
        role.jobRoles?.toLowerCase().includes(search)
      );
      setFilteredJobRoles(filtered);
    }
  };

  const handleCityChange = (e) => {
    const value = e.target.value;
    const formattedValue = value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
    setCityName(formattedValue);
    
    const selectedCity = cities.find(city => city.city.toUpperCase() === formattedValue.toUpperCase());
    if (selectedCity) {
      fetchAreas(selectedCity.id);
      setAreaName('');
    }
    removeError('cityName');
  };

  const handleAreaChange = (e) => {
    setAreaName(e.target.value);
    removeError('areaName');
  };

  const handleOtpChange = (index, value) => {
    if (value.length <= 1 && /^\d*$/.test(value)) {
      const newOtp = [...otpValues];
      newOtp[index] = value;
      setOtpValues(newOtp);
      setShowOtpError(false);
      
      if (value && index < 5) {
        otpInputsRef.current[index + 1]?.focus();
      }
    }
  };

  const handleOtpKeyDown = (index, e) => {
    if (e.key === 'Backspace' && !otpValues[index] && index > 0) {
      otpInputsRef.current[index - 1]?.focus();
    }
  };

  // Salary handlers
  const handleSalaryFromChange = (e) => {
    const val = e.target.value.replace(/\D/g, '');
    const numVal = val ? parseInt(val) : 0;
    setSalaryRange({ ...salaryRange, from: numVal });
    setMinSalary(numVal.toString());
  };

  const handleSalaryToChange = (e) => {
    const val = e.target.value.replace(/\D/g, '');
    const numVal = val ? parseInt(val) : 0;
    setSalaryRange({ ...salaryRange, to: numVal });
    setMaxSalary(numVal.toString());
  };

  const handleSalaryRangeChange = (range) => {
    setSalaryRange(range);
    setMinSalary(range.from.toString());
    setMaxSalary(range.to.toString());
  };

  const handleSalaryConfirm = () => {
    if (salaryRange.from >= 10000 && salaryRange.to >= 10000) {
      setMinSalary(salaryRange.from.toString());
      setMaxSalary(salaryRange.to.toString());
      setShowSalaryModal(false);
      removeError('salary');
    } else {
      document.getElementById('salary_error_txt')?.classList.remove(styles['d-none']);
    }
  };

  // Key Skills Search Handler
  const handleKeySkillSearch = (e) => {
    const searchTerm = e.target.value.toLowerCase();
    setKeySkillSearchTerm(searchTerm);
    
    if (searchTerm.trim() === '') {
      setFilteredKeySkills([]);
    } else {
      const filtered = keySkillsList.filter(skill => 
        skill.skill.toLowerCase().includes(searchTerm)
      );
      setFilteredKeySkills(filtered);
    }
  };

  // Validation
  const validateForm = () => {
    let newNoError = 0;
    const newErrFieldsArr = [];
    const newErrors = {};
    
    if (!employerId) {
      addError('employerId');
      newErrors.employerId = 'Please enter Employer id';
      newErrFieldsArr.push('EmployerLabel');
      newNoError++;
    }
    
    if (!jobRoleCategory) {
      addError('jobRoleCategory');
      newErrors.jobRoleCategory = 'Please select job role';
      newErrFieldsArr.push('jobRoleLabel');
      newNoError++;
    }
    
    if (benefitsText.length === 0) {
      addError('benefits_text_area');
      newErrors.benefits = 'Please select benefits';
      newErrFieldsArr.push('benefitsLabel');
      newNoError++;
    }
    
    if (!minSalary) {
      addError('minSalary');
      newErrors.salary = 'Please select salary range';
      newErrFieldsArr.push('salaryLabel');
      newNoError++;
    }
    
    if (!maxSalary) {
      addError('maxSalary');
      newErrors.salary = 'Please select salary range';
      newErrFieldsArr.push('salaryLabel');
      newNoError++;
    }
    
    if (!companyName) {
      addError('companyName');
      newErrors.companyName = 'Please enter company name';
      newNoError++;
    }
    
    if (!locationUrl) {
      addError('locationUrl');
      newErrors.locationUrl = 'Please enter location URL';
      newNoError++;
    }
    
    if (!minExp) {
      addError('minExp');
      newErrors.minExp = 'Please select experience';
      newErrFieldsArr.push('minExpLabel');
      newNoError++;
    }
    
    if (keySkills.length === 0) {
      addError('keySkill_input');
      newErrors.keySkills = 'Please select key skills';
      newErrFieldsArr.push('keySkillsLabel');
      newNoError++;
    }
    
    if (educationQualification.length === 0) {
      addError('edu_quality_error');
      newErrors.education = 'Please select education';
      newErrFieldsArr.push('educationLabel');
      newNoError++;
    }
    
    if (male === 0 && female === 0) {
      addError('gender_male');
      newErrors.gender = 'Please enter at least one candidate';
      newErrFieldsArr.push('genderLabel');
      newNoError++;
    } else if (parseInt(noOfOpenings) > 0 && male + female !== parseInt(noOfOpenings)) {
      addError('gender_male');
      newErrors.gender = `Total candidates (${male + female}) should equal no of openings (${noOfOpenings})`;
      newNoError++;
    }
    
    if (!noOfOpenings) {
      addError('noOfOpenings');
      newErrors.noOfOpenings = 'Please enter no of openings';
      newErrFieldsArr.push('NoOfOpeningLabel');
      newNoError++;
    }
    
    if (!cityName) {
      addError('cityName');
      newErrors.cityName = 'Please enter your city/town';
      newNoError++;
    } else {
      const cityExists = cities.some(city => city.city.toUpperCase() === cityName.toUpperCase());
      if (!cityExists) {
        addError('cityName');
        newErrors.cityName = 'Result not found';
        setCityName('');
        newNoError++;
      }
    }
    
    if (!areaName) {
      addError('areaName');
      newErrors.areaName = 'Please enter your area';
      newNoError++;
    }
    
    if (!addressText) {
      addError('addressText');
      newErrors.addressText = 'Please enter your address';
      newNoError++;
    }
    
    if (!otType) {
      addError('overTime-1');
      newErrors.otType = 'Please select overtime';
      newErrFieldsArr.push('overTimeLabel');
      newNoError++;
    }
    
    if (!shiftType) {
      addError('option-1');
      newErrors.shiftType = 'Please select shift type';
      newErrFieldsArr.push('shiftLabel');
      newNoError++;
    }
    
    if (!workHours) {
      addError('workHours');
      newErrors.workHours = 'Please select work hours';
      newErrFieldsArr.push('workHoursLabel');
      newNoError++;
    }
    
    if (!contactPersonName) {
      addError('contactPersonName');
      newErrors.contactPersonName = 'Please enter contact person';
      newErrFieldsArr.push('contactNameLabel');
      newNoError++;
    }
    
    if (!contactNum) {
      addError('contactNum');
      newErrors.contactNum = 'Please enter contact number';
      newErrFieldsArr.push('contactNumberLabel');
      newNoError++;
    } else if (contactNum.length !== 10) {
      addError('contactNum');
      newErrors.contactNum = 'Please enter valid 10-digit number';
      newErrFieldsArr.push('contactNumberLabel');
      newNoError++;
    }
    
    if (alternateNum && alternateNum.length !== 10) {
      addError('alternateNum');
      newErrors.alternateNum = 'Please enter valid 10-digit number';
      newErrFieldsArr.push('alternateNum');
      newNoError++;
    }
    
    // if (!whatAppNumber) {
    //   addError('whatAppNumber');
    //   newErrors.whatAppNumber = 'Please enter WhatsApp number';
    //   newErrFieldsArr.push('WhatsappNumberLabel');
    //   newNoError++;
    // } else if (whatAppNumber.length !== 10) {
    //   addError('whatAppNumber');
    //   newErrors.whatAppNumber = 'Please enter valid 10-digit WhatsApp number';
    //   newErrFieldsArr.push('whatAppNumber');
    //   newNoError++;
    // }
    // WhatsApp number validation - FIXED
const whatsappNumStr = whatAppNumber ? whatAppNumber.toString() : '';
const cleanedWhatsApp = whatsappNumStr.replace(/\D/g, ''); // Remove non-digits

if (!whatsappNumStr || whatsappNumStr.trim() === '') {
  addError('whatAppNumber');
  newErrors.whatAppNumber = 'Please enter WhatsApp number';
  newErrFieldsArr.push('WhatsappNumberLabel');
  newNoError++;
} else if (cleanedWhatsApp.length !== 10) {
  addError('whatAppNumber');
  newErrors.whatAppNumber = 'Please enter valid 10-digit WhatsApp number';
  newErrFieldsArr.push('whatAppNumber');
  newNoError++;
} else {
  // Store the cleaned number
  setWhatAppNumber(cleanedWhatsApp);
}
    
    setNoError(newNoError);
    setErrFieldsArr(newErrFieldsArr);
    setErrors(newErrors);
    
    return newNoError === 0;
  };

  const addError = (fieldId) => {
    const element = document.getElementById(fieldId);
    if (element) {
      const formGroup = element.closest(`.${styles['form-group']}`);
      if (formGroup) formGroup.classList.add(styles.error);
    }
  };

  const removeError = (fieldId) => {
    // Remove from errors state
    setErrors(prev => {
      const newErrors = { ...prev };
      delete newErrors[fieldId];
      return newErrors;
    });
    
    // Find the form group element
    let element = null;
    
    switch(fieldId) {
      case 'gender':
        element = document.getElementById('gender_male');
        break;
      case 'salary':
        element = document.getElementById('minSalary');
        break;
      case 'benefits':
        element = document.getElementById('benefits_text_area');
        break;
      case 'keySkills':
        element = document.getElementById('keySkill_input');
        break;
      case 'education':
        element = document.getElementById('edu_quality_error');
        break;
      default:
        element = document.getElementById(fieldId);
    }
    
    if (element) {
      const formGroup = element.closest(`.${styles['form-group']}`);
      if (formGroup) {
        formGroup.classList.remove(styles.error);
      }
    }
  };

  const handleInputChange = (e, setter) => {
    const { id, value } = e.target;
    setter(value);
    removeError(id);
  };

  const handleSelectChange = (e, setter, fieldId) => {
    const value = e.target.value;
    setter(value);
    removeError(fieldId);
  };

  const handleRadioChange = (e, setter, fieldId) => {
    setter(e.target.value);
    removeError(fieldId);
  };

  // Submit function
  const handleSubmit = async () => {
    if (!validateForm()) {
      if (errFieldsArr.length > 0) {
        const element = document.getElementById(errFieldsArr[0]);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }
      return;
    }
    
    setLoading(true);
    
    let jobExp, jobMaxExp;
    
    if (minExp === '0 - 1') {
      jobExp = '0';
      jobMaxExp = '1';
    } else if (minExp === 'Freshers') {
      jobExp = '0';
      jobMaxExp = '0';
    } else {
      jobExp = minExp;
      jobMaxExp = minExp;
    }
    
    // Format keyskills - FIXED: Remove the "_ks" and "/" from selectedKeySkill
    const keyskills = selectedKeySkill.map(skill => skill.split('/')[0]).join(', ');
    
    const jobData = {
      employerId: parseInt(employerId),
      jobType: "Full Time",
      industry: jobRole || jobRoleCategory,
      jobCategory: jobRoleCategory,
      salary: minSalary,
      maxSalary: maxSalary,
      jobExp: jobExp,
      jobMaxExp: jobMaxExp,
      qualification: educationQualification.join(', '),
      contactPersonName: contactPersonName,
      mobileNumber: contactNum,
      companyName: companyName,
      alternateMobileNumber: alternateNum || null,
      shiftType: shiftType,
      workHours: workHours,
      ot: otType,
      companyLocationUrl: locationUrl,
      jobLatitude: userLocationDetails.latitude,
      jobLongitude: userLocationDetails.longitude,
      jobCountry: country,
      pincode: userLocationDetails.pin_code,
      state: userLocationDetails.state,
      country: userLocationDetails.country,
      jobLocation: cityName,
      area: areaName,
      jobLocationAddr: addressText,
      benefits: benefitsText.join(', '),
      keyskills: keyskills,
      male: male,
      female: female,
      noOfOpenings: parseInt(noOfOpenings),
      whatsappNumber: whatAppNumber,
      jobDescription: jobDescription,
    };

    try {
      let url;
      if (jobId) {
        url = `${API_BASE_URL}/updateNewPostJob?jobId=${jobId}`;
      } else {
        url = `${ADMIN_API_BASE_URL}/newPostJob?admin_id=${urlParams.get('adminId')}`;
      }
      
      const response = await fetch(url, {
        // method: jobId ? 'PUT' : 'POST',
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(jobData)
      });
      
      const data = await response.json();
      
      if (data.status || data?.data?.id) {
        if (selectedFile) {
          await uploadJobDescription(jobId || data.data.id);
        }
        showSuccessPopup(jobId ? 'Job Updated Successfully' : 'Job Published Successfully');
         if (onSuccess) {
    onSuccess();  // Add this line
  }
        // Call onClose and redirect after success
        setTimeout(() => {
          if (onClose) {
            onClose(); // Close the modal
          }
        //   window.location.href = 'manage-jobs';
        }, 1500);
      } else {
        alert(data.message || 'Failed to submit job');
      }
    } catch (error) {
      console.error('Error submitting job:', error);
      alert('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const uploadJobDescription = async (id) => {
    const formData = new FormData();
    formData.append('file', selectedFile);

    try {
      await fetch(`${ADMIN_API_BASE_URL}/jobDescriptionUpload?id=${id}`, {
        method: 'PUT',
        body: formData
      });
    } catch (error) {
      console.error('Error uploading file:', error);
    }
  };

  const showSuccessPopup = (message) => {
    const popup = document.createElement('div');
    popup.className = styles['success-popup'];
    popup.innerHTML = `
      <div class="${styles['success-content']}">
        <svg viewBox="0 0 100 100">
          <circle cx="50" cy="50" r="46.5" fill="none" stroke="rgba(76, 175, 80, 0.5)" stroke-width="5"/>
          <path d="M67,93 A46.5,46.5 0 1,0 7,32 L43,67 L88,19" fill="none" stroke="#4CAF50" stroke-width="5" stroke-linecap="round"/>
        </svg>
        <p>${message}</p>
      </div>
    `;
    document.body.appendChild(popup);
    setTimeout(() => popup.remove(), 2000);
  };

  // Helper function to allow only numbers
  const allowOnlyNumber = (e, maxLength) => {
    const value = e.target.value.replace(/\D/g, '');
    if (value.length > maxLength) {
      return value.slice(0, maxLength);
    }
    return value;
  };

  // Radio button functions
  const radioBtnFn = () => {
    // Update active class for shift buttons
    const option1 = document.getElementById('option-1');
    const option2 = document.getElementById('option-2');
    
    if (option1?.checked) {
      document.querySelector(`.${styles.shiftBtn1}`)?.classList.add(styles.activeBtn);
      document.querySelector(`.${styles.shiftBtn2}`)?.classList.remove(styles.activeBtn);
    } else if (option2?.checked) {
      document.querySelector(`.${styles.shiftBtn1}`)?.classList.remove(styles.activeBtn);
      document.querySelector(`.${styles.shiftBtn2}`)?.classList.add(styles.activeBtn);
    }
  };

  const overTimeBtnFn = () => {
    // Update active class for overtime buttons
    const ot1 = document.getElementById('overTime-1');
    const ot2 = document.getElementById('overTime-2');
    
    if (ot1?.checked) {
      document.querySelector(`.${styles.otBtn1}`)?.classList.add(styles.activeBtn);
      document.querySelector(`.${styles.otBtn2}`)?.classList.remove(styles.activeBtn);
    } else if (ot2?.checked) {
      document.querySelector(`.${styles.otBtn1}`)?.classList.remove(styles.activeBtn);
      document.querySelector(`.${styles.otBtn2}`)?.classList.remove(styles.activeBtn);
    }
  };

  return (
    <div className={styles['post-job-content']}>
      {/* Header */}
      <section className={styles.navBar}>
        {/* <div className="ms-4 p-2">
          <nav>
            <a href="#"><img width="175px" src="/images/brand-logo.png" className={styles.brandLogo} alt="Taizo" /></a>
          </nav>
        </div> */}
      </section>

      {/* Main Form */}
      <div className={styles.post_job_content}>
        <div className={`container-fluid-sm ${styles.post_a_job_form}`}>
          <div className={styles.postJobContainer}>
            {/* Heading */}
            <div className={styles.pstJobHead}>
              {/* <p className="text-sm-center">Job Post Update </p> */}
              <div className={`d-grid ${styles['justify-content-end']} mb-4`} style={{ marginTop: '-45px' }}>
                {/* <div>
                  <span className={styles.save_job_btn} style={{ cursor: 'pointer' }} onClick={() => setShowSavePopup(true)}>
                    <img src={saveIcon} width="15px" alt="save" />
                    <span style={{ fontSize: '15px' }}> &nbsp; Save</span>
                  </span>
                  <div className="d-inline-block">
                    <span className={`${styles.closeBtn} mx-3 mx-sm-5`} onClick={() => window.history.back()}></span>
                  </div>
                </div> */}
              </div>
            </div>

            {/* Job Details Section */}
            <div className={`py-3 px-md-3 px-lg-4 px-sm-2`}>
              <span className={styles['text-green']} style={{ fontWeight: 600 }}>Job Details</span>

              <div className={`row mb-3`}>
                <div className={`col-sm-6`}>
                  <div className={styles['form-group']}>
                    <label htmlFor="employerId">Employer Id</label>
                    <input
                      className={`${styles['form-control']} only-number`}
                      type="number"
                      id="employerId"
                      value={employerId}
                      onChange={(e) => setEmployerId(e.target.value.replace(/\D/g, '').slice(0, 10))}
                      placeholder="Enter your number"
                      readOnly
                    />
                    {errors.employerId && <div className={styles.validMsg}>{errors.employerId}</div>}
                  </div>
                </div>
              </div>

              {/* Job Role and No of Openings */}
              <div className={`row mb-3`}>
                <div className={`col-sm-6`}>
                  <div className={styles['form-group']}>
                    <label htmlFor="jobRoleCategory">Job Role</label>
                    <div className={styles['field-wrapper']} onClick={() => setShowJobRoleModal(true)}>
                      <input
                        type="text"
                        id="jobRoleCategory"
                        className={`${styles['form-control']} ${styles['field-input']} ${styles['bg-white']}`}
                        placeholder="select"
                        value={selectedJobRole || jobRoleCategory}
                        readOnly
                      />
                      <div className={styles['field-arrow']}>
                        <img src={downArrow} alt="dropdown" />
                      </div>
                    </div>
                    {errors.jobRoleCategory && <div className={`${styles.validMsg} mt-2`}>{errors.jobRoleCategory}</div>}
                  </div>
                </div>

                <div className={`col-sm-6`}>
                  <div className={styles['form-group']}>
                    <label htmlFor="noOfOpenings">No Of Openings</label>
                    <input
                      type="text"
                      id="noOfOpenings"
                      className={styles['form-control']}
                      placeholder="No Of Openings"
                      value={noOfOpenings}
                      onChange={(e) => {
                        const val = e.target.value.replace(/\D/g, '').slice(0, 3);
                        setNoOfOpenings(val);
                        removeError('noOfOpenings');
                      }}
                    />
                    {errors.noOfOpenings && <div className={`${styles.validMsg} ${styles.noOfOpenigsError} mt-3`}>{errors.noOfOpenings}</div>}
                  </div>
                </div>
              </div>

              {/* Gender Counters */}
              <div className={`row`}>
                <div className={`col-sm-6`}>
                  <div className={`${styles['form-group']} mt-2`}>
                    <div className={`d-flex flex-row flex-wrap`}>
                      <div className={`${styles['no-of-openings-amount-div']} me-3 mb-2`}>
                        <div className={styles['no-of-openings-div']}>
                          <div className={styles['no-of-openings-div1']}>
                            <label className={styles['no-of-openings-label']}>No. of Male(s)</label>
                            <div className={styles['no-of-openings-add-and-redu']}>
                              <div className={styles['no-of-openings-reduce-btn']} onClick={handleMaleDecrease}>
                                <img className={styles['reduce-icon']} alt="reduce" src={removeIcon} />
                              </div>
                              <div className={styles['no-of-openings-value-filed']} style={{ padding: '10px 10px' }}>
                                <div className={styles['no-of-openings']} id="gender_male">{male}</div>
                              </div>
                              <div className={styles['no-of-openings-add-btn']} onClick={handleMaleIncrease}>
                                <img className={styles['add-icon']} alt="add" src={addIcon} />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className={styles['no-of-openings-amount-div']}>
                        <div className={styles['no-of-openings-div']}>
                          <div className={styles['no-of-openings-div1']}>
                            <label className={styles['no-of-openings-label']}>No. of Female(s)</label>
                            <div className={styles['no-of-openings-add-and-redu']}>
                              <div className={styles['no-of-openings-reduce-btn']} onClick={handleFemaleDecrease}>
                                <img className={styles['reduce-icon']} alt="reduce" src={removeIcon} />
                              </div>
                              <div className={styles['no-of-openings-value-filed']} style={{ padding: '10px 10px' }}>
                                <div className={styles['no-of-openings']} id="gender_female">{female}</div>
                              </div>
                              <div className={styles['no-of-openings-add-btn']} onClick={handleFemaleIncrease}>
                                <img className={styles['add-icon']} alt="add" src={addIcon} />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {errors.gender && <div className={`${styles.validMsg} ${styles.maleFemaleErr} mt-2`}>{errors.gender}</div>}
                  </div>
                </div>

                <div className={`col-sm-6`}>
                  <div className={`mt-2 ${styles['form-group']} ms-3`}>
                    <label className={styles['no-of-openings-label']}>Job Description</label>
                    <textarea
                      className={styles['form-control']}
                      placeholder="Job Description"
                      id="JobDescription"
                      value={jobDescription}
                      onChange={(e) => setJobDescription(e.target.value)}
                      rows="3"
                    />
                  </div>
                </div>
              </div>

              {/* Salary and File Upload */}
              <div className={`row`}>
                <div className={`col-sm-6`}>
                  <div className={styles['form-group']}>
                    <label>Salary (per month)</label>
                    <div className={`row`}>
                      <div className={`col-4`}>
                        <input type="text" disabled className={styles['form-control']} placeholder="₹ INR" />
                      </div>
                      <div className={`col-4`}>
                        <div onClick={() => setShowSalaryModal(true)} style={{ cursor: 'pointer' }}>
                          <input
                            type="text"
                            id="minSalary"
                            style={{ backgroundColor: 'white' }}
                            className={styles['form-control']}
                            placeholder="Min"
                            value={minSalary}
                            readOnly
                          />
                        </div>
                      </div>
                      <div className={`col-4`}>
                        <div onClick={() => setShowSalaryModal(true)} style={{ cursor: 'pointer' }}>
                          <input
                            type="text"
                            id="maxSalary"
                            style={{ backgroundColor: 'white' }}
                            className={styles['form-control']}
                            placeholder="Max"
                            value={maxSalary}
                            readOnly
                          />
                        </div>
                      </div>
                    </div>
                    {errors.salary && <div className={styles.validMsg}>{errors.salary}</div>}
                  </div>
                </div>

                <div className={`col-sm-6`}>
                  <div className={`${styles['form-group']} mx-3 mb-1`}>
                    <div className={styles['custom-file']}>
                      <label htmlFor="formFile" className="form-label">Job Description (Upload File)</label>
                      <input
                        className={styles['form-control']}
                        type="file"
                        id="formFile"
                        ref={fileInputRef}
                        onChange={handleFileChange}
                      />
                    </div>
                    {jobDescriptionLink && (
                      <p id="jobDescriptionLinkName" style={{ fontSize: '11px', fontWeight: 'bold' }}>
                        JD Description: <a href={jobDescriptionLink} target="_blank" rel="noopener noreferrer">{jobDescriptionLink}</a>
                      </p>
                    )}
                  </div>
                </div>
              </div>

              {/* Benefits and Experience */}
              <div className={`row mb-3`}>
                <div className={`col-sm-6 ${styles['adddetails-margin-top']}`}>
                  <div className={styles['form-group']}>
                    <label>Benefits</label>
                    <div className={styles['benefits-field-wrapper']} onClick={() => setShowBenefitsModal(true)}>
                      <textarea
                        className={`${styles['form-control']} ${styles['benefits-textarea']}`}
                        id="benefits_text_area"
                        placeholder="Ex: PF, ESI"
                        value={benefitsText.join(', ')}
                        readOnly
                      />
                      <div className={styles['field-arrow']}>
                        <img src={downArrow} alt="dropdown" />
                      </div>
                    </div>
                    {errors.benefits && <div className={`${styles.validMsg} mt-1`}>{errors.benefits}</div>}
                  </div>
                </div>

                <div className={`col-sm-6`}>
                  <div className={`${styles['form-group']} mt-1`}>
                    <label>Minimum Experience</label>
                    <div className={`text-right pe-2`} style={{ marginTop: '-25px', fontSize: '12px', fontWeight: 700, textAlign: 'right', maxHeight: '25px', marginBottom: '-10px' }}>
                      <p>
                        <span>
                          <button
                            className={`${styles['experience-option']} ${minExp === '0 - 1' ? styles.active : ''}`}
                            id="exp0-1"
                            style={{ fontWeight: 700, borderStyle: 'none', background: 'none', cursor: 'pointer' }}
                            onClick={() => {
                              setMinExp('0 - 1');
                              removeError('minExp');
                            }}
                          >
                            0 - 1
                          </button>
                        </span>
                        <span>
                          <button
                            id="expFresher"
                            className={`ms-2 ${styles['experience-option']} ${minExp === 'Freshers' ? styles.active : ''}`}
                            style={{ fontWeight: 600, borderStyle: 'none', background: 'none', cursor: 'pointer' }}
                            onClick={() => {
                              setMinExp('Freshers');
                              removeError('minExp');
                            }}
                          >
                            Freshers
                          </button>
                        </span>
                      </p>
                    </div>
                    <div className={styles['field-wrapper']}>
                      <select
                        className={`${styles['form-control']} ${styles['field-input']}`}
                        id="minExp"
                        value={minExp}
                        onChange={(e) => handleSelectChange(e, setMinExp, 'minExp')}
                      >
                        <option value="">Ex: 2 - 4 Years</option>
                        <option value="Freshers">Fresher</option>
                        <option value="0 - 1">0 - 1</option>
                        <option value="1">1</option>
                        <option value="2">2</option>
                        <option value="3">3</option>
                        <option value="4">4</option>
                        <option value="5">5</option>
                        <option value="6">6</option>
                        <option value="7">7</option>
                        <option value="8">8</option>
                        <option value="9">9</option>
                        <option value="10">10</option>
                      </select>
                      <div className={styles['field-arrow']}>
                        {/* <img src={downArrow} alt="dropdown" /> */}
                      </div>
                    </div>
                    {errors.minExp && <div className={`${styles.validMsg} mt-2`}>{errors.minExp}</div>}
                  </div>
                </div>
              </div>

              {/* Key Skills and Education */}
              <div className={`row`}>
                <div className={`col-sm-6`}>
                  <div className={styles['form-group']}>
                    <label>Key Skills</label>
                    <div className={styles['field-wrapper']} onClick={() => setShowKeySkillsPopup(true)}>
                      <div className={`${styles['form-control']} ${styles['field-input']}`} id="keySkill_input">
                        {keySkills.length > 0 ? keySkills.join(', ') : <span className={styles.placeholder}>Select key skills</span>}
                      </div>
                      <div className={styles['field-arrow']}>
                        <img src={downArrow} alt="dropdown" />
                      </div>
                    </div>
                    {errors.keySkills && <div className={styles.validMsg}>{errors.keySkills}</div>}
                  </div>
                </div>

                <div className={`col-sm-6`}>
                  <div className={styles['form-group']}>
                    <label>Educational Qualification</label>
                    <div className={styles['field-wrapper']} onClick={() => setShowEduQualityPopup(true)}>
                      <div className={`${styles['form-control']} ${styles['field-input']}`} id="edu_quality_input">
                        {educationQualification.length > 0 ? educationQualification.join(', ') : <span className={styles.placeholder}>Select education qualification</span>}
                      </div>
                      <div className={styles['field-arrow']}>
                        <img src={downArrow} alt="dropdown" />
                      </div>
                    </div>
                    {errors.education && <div className={`${styles.validMsg} mt-2`} id="edu_quality_error">{errors.education}</div>}
                  </div>
                </div>
              </div>
            </div>

            {/* Additional Details Section */}
            <div className={styles.addDetailsContainer}>
              <div>
                <button className={`${styles.addDetailsBtn} d-none`}>+ Additional Details</button>
              </div>
              <div className={styles.addDetaisContainer}>
                <div className={`py-3 px-md-3 px-lg-4 px-sm-2`}>
                  <span className={styles['text-green']} style={{ fontWeight: 600 }}>Additional Details</span>
                  <button className={`d-none`} id="cancelAddDetails"> &nbsp; Cancel</button>

                  <div className={`row`} style={{ marginBottom: '0px' }}>
                  {/* Shift */}
<div className={`col-sm-6`} style={{ margin: '0px' }}>
  <div className={styles['form-group']}>
    <label>Shift</label><br />
    <div className={styles['radio-group']}>
      <label 
        htmlFor="option-1"
        className={`${styles['radio-label']} ${shiftType === 'General' ? styles.active : ''}`}
      >
        <input
          autoComplete="off"
          value="General"
          type="radio"
          onChange={(e) => {
            handleRadioChange(e, setShiftType, 'shiftType');
          }}
          name="shiftType"
          id="option-1"
          checked={shiftType === 'General'}
        />
        <span>General</span>
      </label>
      
      <label 
        htmlFor="option-2"
        className={`${styles['radio-label']} ${shiftType === 'Rotational' ? styles.active : ''}`}
      >
        <input
          autoComplete="off"
          value="Rotational"
          type="radio"
          onChange={(e) => {
            handleRadioChange(e, setShiftType, 'shiftType');
          }}
          name="shiftType"
          id="option-2"
          checked={shiftType === 'Rotational'}
        />
        <span>Rotational</span>
      </label>
    </div>
    {errors.shiftType && <div className={styles.validMsg}>{errors.shiftType}</div>}
  </div>
</div>

                  {/* Over Time */}
<div className={`col-sm-6 ${styles['adddetails-margin-top']}`}>
  <div className={styles['form-group']}>
    <label>Over Time</label><br />
    <div className={styles['radio-group']}>
      <label 
        htmlFor="overTime-1"
        className={`${styles['radio-label']} ${otType === 'Yes' ? styles.active : ''}`}
      >
        <input
          autoComplete="off"
          type="radio"
          value="Yes"
          onChange={(e) => {
            handleRadioChange(e, setOtType, 'otType');
          }}
          name="otType"
          id="overTime-1"
          checked={otType === 'Yes'}
        />
        <span>Yes</span>
      </label>
      
      <label 
        htmlFor="overTime-2"
        className={`${styles['radio-label']} ${otType === 'No' ? styles.active : ''}`}
      >
        <input
          autoComplete="off"
          value="No"
          type="radio"
          onChange={(e) => {
            handleRadioChange(e, setOtType, 'otType');
          }}
          name="otType"
          id="overTime-2"
          checked={otType === 'No'}
        />
        <span>No</span>
      </label>
    </div>
    {errors.otType && <div className={styles.validMsg}>{errors.otType}</div>}
  </div>
</div>
                  </div>

                  <div className={`row`} style={{ marginTop: '0px' }}>
                    <div className={`col-sm-6`}>
                      <div className={styles['form-group']}>
                        <label>Work Hours</label>
                        <div data-bs-toggle="dropdown">
                          <div className={styles['field-wrapper']}>
                            <select
                              className={`${styles['form-control']} ${styles['field-input']}`}
                              id="workHours"
                              value={workHours}
                              onChange={(e) => handleSelectChange(e, setWorkHours, 'workHours')}
                            >
                              <option value="">Ex: 8 hours</option>
                              <option value="8 hours">8 hours</option>
                              <option value="9 hours">9 hours</option>
                              <option value="10 hours">10 hours</option>
                              <option value="11 hours">11 hours</option>
                              <option value="12 hours">12 hours</option>
                            </select>
                            <div className={styles['field-arrow']}>
                              {/* <img src={downArrow} alt="dropdown" /> */}
                            </div>
                          </div>
                        </div>
                        {errors.workHours && <div className={styles.validMsg}>{errors.workHours}</div>}
                      </div>
                    </div>

                    <div className={`col-sm-6`}>
                      <div className={styles['form-group']}>
                        <label>Location url</label>
                        <textarea
                          className={`${styles['form-control']} text-capitalize`}
                          autoComplete="off"
                          rows="1"
                          cols="20"
                          id="locationUrl"
                          placeholder="Location Url"
                          value={locationUrl}
                          onChange={(e) => handleInputChange(e, setLocationUrl)}
                        />
                        {errors.locationUrl && <div className={styles.validMsg}>{errors.locationUrl}</div>}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Contact Details Section */}
            <div className={`py-3 px-md-3 px-lg-4 px-sm-2`}>
              <span className={styles['text-green']} style={{ fontWeight: 600 }}>Contact Details</span>

              <div className={`row`}>
                <div className={`col-sm-6`}>
                  <div className={styles['form-group']}>
                    <label>Contact Person Name</label>
                    <input
                      autoComplete="off"
                      type="text"
                      id="contactPersonName"
                      className={`${styles['form-control']} text-capitalize`}
                      placeholder="Contact Person Name"
                      value={contactPersonName}
                      onChange={(e) => handleInputChange(e, setContactPersonName)}
                    />
                    {errors.contactPersonName && <div className={styles.validMsg}>{errors.contactPersonName}</div>}
                  </div>
                </div>

                <div className={`col-sm-6`}>
                  <div className={styles['form-group']}>
                    <label>Contact Number</label>
                    <div style={{ width: '100%' }}>
                      <div className={`row`}>
                        <div className={`col-3`}>
                          <p className={`${styles.countryCodeWrp} d-grid align-items-center`}>
                            <span className={`ms-1`} style={{ fontSize: '13px', fontWeight: 600 }}>
                              <img style={{ width: '15px', marginLeft: '5px' }} src={indianFlag} alt="IN" />
                              <span> +91</span>
                            </span>
                          </p>
                        </div>
                        <div className={`col-9`}>
                          <input
                            autoComplete="off"
                            type="number"
                            id="contactNum"
                            className={styles['form-control']}
                            placeholder="Contact Number"
                            value={contactNum}
                            onChange={(e) => {
                              const val = e.target.value.slice(0, 10);
                              setContactNum(val);
                              removeError('contactNum');
                            }}
                            onKeyPress={(e) => {
                              if (e.target.value.length >= 10) e.preventDefault();
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    {/* <div className={`d-grid ${styles['justify-content-end']}`} style={{ marginTop: '-1px' }}>
                      <button id="addAltrBtn" onClick={() => setShowAlternateNum(true)}>
                        <span className="iconify" data-icon="carbon:add-alt" style={{ color: '#316dc5', fontSize: '15px' }}></span>
                        &nbsp; Add alternate Mobile Number
                      </button>
                    </div> */}
                    <div className={`d-grid ${styles['justify-content-end']}`} style={{ marginTop: '-1px' }}>
  <button 
    id="addAltrBtn" 
    className={styles['add-alternate-btn']}
    onClick={() => setShowAlternateNum(true)}
  >
    <span className={styles['plus-icon']}>+</span>
    Add alternate Mobile Number
  </button>
</div>
                    {errors.contactNum && <div className={`${styles.validMsg} contactErr`} style={{ marginTop: '-5px' }}>{errors.contactNum}</div>}
                  </div>
                </div>
              </div>

              {/* Alternate Number Section */}
              {showAlternateNum && (
                <div className={`row`}>
                  <div className={`col-sm-6`}>
                    <div className={styles.alterNumContainer}>
                      <div className={styles['form-group']}>
                           <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      <label htmlFor="alternateNum">Alternate Number</label>
      <button 
        id="cancelAltrNum"
        className={styles['cancel-btn']}
        onClick={() => {
          setShowAlternateNum(false);
          setAlternateNum('');
          removeError('alternateNum');
        }}
      >
        Cancel
      </button>
    </div>
                        <div style={{ width: '100%' }}>
                          <div className={`row`}>
                            <div className={`col-3`}>
                              <p className={`${styles.countryCodeWrp} d-grid align-items-center`}>
                                <span className={`ms-1`} style={{ fontSize: '13px', fontWeight: 600 }}>
                                  <img style={{ width: '15px', marginLeft: '5px' }} src={indianFlag} alt="IN" />
                                  <span> +91</span>
                                </span>
                              </p>
                            </div>
                            <div className={`col-9`}>
                              <input
                                autoComplete="off"
                                type="number"
                                id="alternateNum"
                                className={styles['form-control']}
                                placeholder="Alternate Number"
                                value={alternateNum}
                                onChange={(e) => {
                                  const val = e.target.value.slice(0, 10);
                                  setAlternateNum(val);
                                }}
                                onKeyPress={(e) => {
                                  if (e.target.value.length >= 10) e.preventDefault();
                                }}
                              />
                              <div className={`d-grid ${styles['justify-content-end']}`}>
                                <span>
                                  <p className={`${styles['text-green']} verifyTxtAlt d-none pe-2`} style={{ fontSize: '13px', fontWeight: 500, marginTop: '-25px' }}>
                                    verified <img src="/images/verifyImg.png" alt="" />
                                  </p>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className={`d-grid ${styles['justify-content-end']}`} style={{ marginTop: '5px' }}>
                          {/* <button
                            onClick={() => sendOtp(alternateNum, 'alternate')}
                            className={styles['send-otp-btn']}
                            disabled={otpLoading}
                          >
                            {otpLoading ? 'Sending...' : 'Send OTP'}
                          </button> */}
                        </div>
                        {errors.alternateNum && <div className={`${styles.validMsg} alternateNumErr`} style={{ marginTop: '-20px' }}>{errors.alternateNum}</div>}
                      </div>
                    </div>
                  </div>
                </div>
              )}

              <div className={`row`}>
                <div className={`col-sm-6`}>
                  <div className={`${styles['form-group']} ${styles.whatApp_number_wrp}`}>
                    <label htmlFor="whatAppNumber">WhatsApp number</label>
                    <input
                      className={`${styles['form-control']} only-number`}
                      type="number"
                      id="whatAppNumber"
                      maxLength="10"
                      placeholder="Enter your WhatsApp number"
                      value={whatAppNumber}
                      onChange={(e) => {
                        const val = e.target.value.slice(0, 10);
                        setWhatAppNumber(val);
                        removeError('whatAppNumber');
                      }}
                      style={{
                        backgroundImage: `url(${whatsappIcon})`,
                        backgroundRepeat: 'no-repeat',
                        backgroundSize: '20px',
                        backgroundPosition: '97% center',
                        paddingRight: '35px'
                      }}
                    />
                    {errors.whatAppNumber && <div className={styles.validMsg}>{errors.whatAppNumber}</div>}
                  </div>
                </div>

                <div className={`col-sm-6`}>
                  <div className={styles['form-group']}>
                    <label htmlFor="companyName">Company Name</label>
                    <input
                      ref={companyNameInputRef}
                      type="text"
                      id="companyName"
                      className={styles['form-control']}
                      placeholder="Company Name"
                      value={companyName}
                      onChange={(e) => {
                        setCompanyName(e.target.value);
                        removeError('companyName');
                      }}
                    />
                    {errors.companyName && <div className={styles.validMsg}>{errors.companyName}</div>}
                  </div>
                </div>
              </div>

              <div className={`row`}>
                <div className={`col-sm-6`}>
                  <div className={styles['form-group']}>
                    <div>
                      <label htmlFor="cityName">City</label>
                      <input
                        type="text"
                        list="city_list"
                        className={`${styles['form-control']} text-capitalize`}
                        placeholder="Ex: Chennai"
                        id="cityName"
                        autoComplete="off"
                        style={{ backgroundColor: 'white' }}
                        value={cityName}
                        onChange={handleCityChange}
                      />
                      <datalist id="city_list">
                        {cities.map((city, index) => (
                          <option key={index} data-cityId={city.id} value={city.city} />
                        ))}
                      </datalist>
                      <div className={`d-grid ${styles['justify-content-end']} pe-3`} style={{ marginTop: '-20px' }}>
                        <span className="iconify" data-icon="il:arrow-down" style={{ fontSize: '10px' }}></span>
                      </div>
                    </div>
                    {errors.cityName && <div className={`${styles.validMsg} mt-4 city_err_text`}>{errors.cityName}</div>}
                  </div>
                </div>

                <div className={`col-sm-6 mt-4 mt-sm-0`}>
                  <div className={styles['form-group']}>
                    <label htmlFor="areaName">Area</label>
                    <input
                      type="text"
                      list="areaDt"
                      className={styles['form-control']}
                      autoComplete="off"
                      placeholder="Ex: Korattur"
                      id="areaName"
                      value={areaName}
                      onChange={handleAreaChange}
                      maxLength="45"
                    />
                    <datalist id="areaDt">
                      {areas.map((area, index) => (
                        <option key={index} value={area.area} />
                      ))}
                    </datalist>
                    {errors.areaName && <div className={styles.validMsg}>{errors.areaName}</div>}
                  </div>
                </div>
              </div>

              <div className={styles['form-group']}>
                <label htmlFor="addressText">Address</label>
                <textarea
                  className={styles['form-control']}
                  id="addressText"
                  placeholder="Ex: No-943, 39th Street, Korattur, Chennai."
                  cols="30"
                  rows="3"
                  value={addressText}
                  onChange={(e) => handleInputChange(e, setAddressText)}
                />
                {errors.addressText && <div className={styles.validMsg}>{errors.addressText}</div>}
              </div>

              {/* WhatsApp Notification Toggle */}
              {/* <div className={`${styles['form-group']} d-grid ${styles['justify-content-center']} d-none`}>
                <div>
                  <button type="button" style={{ backgroundColor: '#70dea236', border: '0px green', padding: '3px 15px 8px 15px', marginLeft: '14px', marginTop: '10px', borderRadius: '4px', fontSize: '13px' }}>
                    <span className="iconify" data-icon="fontisto:whatsapp" style={{ color: '#1cb260', fontSize: '20px' }}></span>
                    <span> &nbsp; Get regular candidate response updates via WhatsApp</span>
                    <label className="switch my-2">
                      <input
                        type="checkbox"
                        checked={whatsappNoti}
                        name="whatsAppCheck"
                        id="whatsAppCheck"
                        onChange={(e) => {
                          if (!e.target.checked) {
                            setShowWhatsAppAlert(true);
                          } else {
                            setWhatsappNoti(true);
                          }
                        }}
                      />
                      <span className="slider round"></span>
                    </label>
                  </button>
                </div>
              </div> */}
            </div>

            {/* Submit Button */}
            {/* <div className={`d-grid ${styles['justify-content-center']} mt-2 mb-1`}>
              <button
                onClick={handleSubmit}
                id="btn_publish"
                className={styles['api-btn']}
                style={{ width: 'auto !important', minWidth: '150px' }}
                disabled={loading}
              >
                {loading ? 'Updating...' : 'Update'}
              </button>
              <div className={styles['form-group']}>
                <p className={styles.validMsg}>Some details are missing</p>
              </div>
            </div> */}
            {/* Submit Button */}
<div className={`d-grid ${styles['justify-content-center']} mt-4 mb-3`}>
  <button
    onClick={handleSubmit}
    id="btn_publish"
    className={styles['publish-btn']}
    disabled={loading}
    style={{
      background: '#1cb260',
      color: 'white',
      border: 'none',
      padding: '12px 50px',
      borderRadius: '5px',
      fontSize: '14px',
      fontWeight: '600',
      cursor: loading ? 'not-allowed' : 'pointer',
      opacity: loading ? 0.5 : 1,
      minWidth: '150px'
    }}
  >
    {loading ? 'Updating...' : 'Update'}
  </button>
  
  {/* Error message - only show when there are validation errors */}
  {Object.keys(errors).length > 0 && (
    <div className={styles['form-group']} style={{ textAlign: 'center', marginTop: '10px' }}>
      <p className={styles.validMsg} style={{ color: '#ff4d4d', fontSize: '14px' }}>
        Some details are missing
      </p>
    </div>
  )}
</div>
{/* 
            <p className={`text-center mt-3`} style={{ fontSize: '13px' }}>
              If you have any issues, please <a className="text-primary" href="https://wame.pro/taizo.in" target="_blank" rel="noopener noreferrer">Click Here</a>
            </p> */}
          </div>
        </div>
      </div>

      {/* JOB ROLE MODAL */}
      {showJobRoleModal && (
        <div className={styles['modal-overlay']}>
          <div className={`${styles['modal-content']} ${styles['job-role-modal']}`}>
            <div className={styles['modal-header']}>
              <h4>Select Industry?</h4>
              <button className={styles['close-btn']} onClick={() => setShowJobRoleModal(false)}>×</button>
            </div>

            <div className={styles['industries-list']}>
              {industries.map(industry => (
                <button
                  key={industry.id}
                  type="button"
                  className={`${styles['btn-job-industry']} ${selectedIndustry === industry.id ? styles.active : ''}`}
                  onClick={() => {
                    if (selectedIndustry === industry.id) return;
                    setSelectedJobRole('');
                    setJobRoleCategory('');
                    setJobRole('');
                    setFilteredJobRoles([]);
                    if (jobRoleSearchRef.current) {
                      jobRoleSearchRef.current.value = '';
                    }
                    setSelectedIndustry(industry.id);
                    fetchJobRoles(industry.id);
                    removeError('jobRoleCategory');
                  }}
                >
                  {industry.industry}
                </button>
              ))}
            </div>

            <div className={styles.divider}></div>

            <div className={styles['modal-header']} style={{ marginTop: '10px' }}>
              <h4>Select Job Role?</h4>
            </div>

            {selectedIndustry && (
              <div className={styles['search-container']}>
                <input
                  ref={jobRoleSearchRef}
                  type="text"
                  className={styles['job_role_auto-search']}
                  placeholder="Search job roles"
                  onChange={handleJobRoleSearch}
                />
                <span className={styles['search-icon']}>🔍</span>
              </div>
            )}

            {!selectedIndustry && (
              <div className={styles['no-industry-message']}>
                Please select an industry first
              </div>
            )}

            {selectedIndustry && (
              <div className={styles['job-roles-container']}>
                {loading ? (
                  <div className={styles.loading}>Loading...</div>
                ) : (
                  (filteredJobRoles.length > 0 ? filteredJobRoles : jobRoles).map(role => (
                    <button
                      key={role.id}
                      type="button"
                      className={`${styles['job-role-item']} ${selectedJobRole === role.jobRoles ? styles.selected : ''}`}
                      onClick={() => {
                        setSelectedJobRole(role.jobRoles);
                        setJobRoleCategory(role.jobRoles);
                        setJobRole(role.jobRoles);
                        setShowJobRoleModal(false);
                        removeError('jobRoleCategory');
                      }}
                    >
                      {role.jobRoles}
                      {selectedJobRole === role.jobRoles && (
                        <span className={styles['check-mark']}>✓</span>
                      )}
                    </button>
                  ))
                )}
              </div>
            )}

            <div className={`${styles['invalid-confirm']} d-none`}>Please fill out this field</div>
          </div>
        </div>
      )}

      {/* SALARY MODAL */}
      {showSalaryModal && (
        <div className={styles['modal-overlay']}>
          <div className={`${styles['modal-content']} ${styles['salary-modal']}`}>
            <div className={styles['modal-header']}>
              <h4>Salary Range</h4>
              <button className={styles['close-btn']} onClick={() => setShowSalaryModal(false)}>×</button>
            </div>

            <div className={styles['salary-inputs']}>
              <div className={styles['input-group']}>
                <label>Min</label>
                <input
                  type="text"
                  className="js-input-from"
                  value={salaryRange.from}
                  onChange={handleSalaryFromChange}
                  placeholder="Min"
                />
              </div>
              <div className={styles['input-group']}>
                <label>Max</label>
                <input
                  type="text"
                  className="js-input-to"
                  value={salaryRange.to}
                  onChange={handleSalaryToChange}
                  placeholder="Max"
                />
              </div>
            </div>

            <div className={styles['salary-value-display']}>
              ₹{salaryRange.from.toLocaleString()} – ₹{salaryRange.to.toLocaleString()}
            </div>

            <RangeSlider
              min={10000}
              max={200000}
              from={salaryRange.from}
              to={salaryRange.to}
              step={500}
              onChange={handleSalaryRangeChange}
            />

            <div id="salary_error_txt" className={`${styles['error-message']} d-none`}>
              Candidates are not responding to jobs with salaries less than INR 10000
            </div>

            <div className={styles['modal-footer']}>
              <button className={styles['cancel-btn']} onClick={() => setShowSalaryModal(false)}>Cancel</button>
              <button className={styles['confirm-btn']} onClick={handleSalaryConfirm}>
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}

      {/* BENEFITS MODAL */}
      {showBenefitsModal && (
        <div className={styles['modal-overlay']}>
          <div className={`${styles['modal-content']} ${styles['benefits-modal']}`}>
            <div className={styles['modal-header']}>
              <h4>
                Select benefits
                {benefits.length >= 10 && <span className={styles['max-warning']}>(Max 10)</span>}
              </h4>
              <button className={styles['close-btn']} onClick={() => setShowBenefitsModal(false)}>×</button>
            </div>

            <div className={`${styles['benefits-scrollbar']} ${styles['scrollbar-primary']}`}>
              <div className={styles['benefits-force-overflow']}>
                <div className={`${styles['modal-body']} mx-3 p-0 ${styles['list-benefits']}`} style={{ background: 'aliceblue' }}>
                  {benefitsList.map((benefit, index) => (
                    <React.Fragment key={index}>
                      <input
                        type="checkbox"
                        id={`benefits_list_${index}`}
                        className={styles['benefit-checkbox']}
                        value={benefit.benefits}
                        checked={benefits.includes(benefit.benefits)}
                        onChange={() => handleBenefitToggle(benefit.benefits)}
                      />
                      <label htmlFor={`benefits_list_${index}`}>{benefit.benefits}</label>
                    </React.Fragment>
                  ))}
                </div>
              </div>
            </div>

            <div className={styles['modal-footer']}>
              <button
                type="button"
                className={styles['confirm-btn']}
                onClick={() => setShowBenefitsModal(false)}
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}

      {/* KEY SKILLS POPUP - FIXED */}
      {showKeySkillsPopup && (
        <div className={styles['modal-overlay']} onClick={(e) => {
          if (e.target.className === styles['modal-overlay']) setShowKeySkillsPopup(false);
        }}>
          <div className={`${styles['modal-content']} ${styles['key-skills-modal']}`}>
            <div className={styles['modal-header']}>
              <h4>Select key skills <span className={styles['max-indicator']}>(Max 5)</span></h4>
              <button className={styles['close-btn']} onClick={() => setShowKeySkillsPopup(false)}>×</button>
            </div>

            {/* Selected Skills Chips */}
            <div className={styles['selected-skills']} id="selected_ks_wrp">
              {selectedKeySkill.length > 0 ? (
                selectedKeySkill.map((item, index) => {
                  const skill = item.split('/')[0];
                  const id = item.split('/')[1];
                  return (
                    <span key={index} className={styles['selected-skill']}>
                      {skill}
                      <button 
                        onClick={(e) => {
                          e.stopPropagation();
                          // Find the skill index and toggle it
                          const skillObj = keySkillsList.find(s => s.skill === skill);
                          if (skillObj) {
                            const skillIndex = keySkillsList.findIndex(s => s.skill === skill);
                            handleKeySkillToggle(skill, skillIndex);
                          }
                        }}
                      >
                        ×
                      </button>
                    </span>
                  );
                })
              ) : (
                <span className={styles['placeholder-text']}>No skills selected</span>
              )}
            </div>

            {/* Search Input */}
            <div className={styles['search-container']}>
              <input
                ref={keyskillsSearchRef}
                type="text"
                className={styles['keyskills-search']}
                placeholder="Search skills"
                value={keySkillSearchTerm}
                onChange={handleKeySkillSearch}
              />
              <span className={styles['search-icon']}>🔍</span>
            </div>

            {/* Skills List */}
            <div className={styles['skills-list-container']}>
              <div className={styles['skills-list']}>
                {(filteredKeySkills.length > 0 ? filteredKeySkills : keySkillsList).map((skill, displayIndex) => {
                  // Find the original index in keySkillsList to maintain correct IDs
                  const originalIndex = keySkillsList.findIndex(s => s.skill === skill.skill);
                  const isSelected = keySkills.includes(skill.skill);
                  
                  return (
                    <label 
                      key={`skill_${originalIndex}`} 
                      className={`${styles['skill-item']} ${isSelected ? styles.selected : ''}`}
                    >
                      <input
                        type="checkbox"
                        id={`${originalIndex}_ks`}
                        checked={isSelected}
                        onChange={() => handleKeySkillToggle(skill.skill, originalIndex)}
                        style={{ display: 'none' }}
                      />
                      <span>{skill.skill}</span>
                    </label>
                  );
                })}
              </div>
            </div>

            <div className={styles['modal-footer']}>
              <button
                type="button"
                className={styles['cancel-btn']}
                onClick={() => {
                  setShowKeySkillsPopup(false);
                  setKeySkillSearchTerm('');
                  setFilteredKeySkills([]);
                }}
              >
                Cancel
              </button>
              <button
                type="button"
                className={styles['confirm-btn']}
                onClick={() => {
                  setShowKeySkillsPopup(false);
                  setKeySkillSearchTerm('');
                  setFilteredKeySkills([]);
                }}
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}

      {/* EDUCATION QUALIFICATION POPUP */}
     {/* EDUCATION QUALIFICATION POPUP */}
{showEduQualityPopup && (
  <div className={styles['modal-overlay']}>
    <div className={`${styles['modal-content']} ${styles['education-modal']}`}>
      <div className={styles['modal-header']}>
        <h4>Educational Qualification</h4>
        <button className={styles['close-btn']} onClick={() => setShowEduQualityPopup(false)}>×</button>
      </div>

      <div className={`${styles['qualifications-list']} mt-3`}>
        <div className={styles.eduQuality_list} style={{ width: 'auto', maxWidth: '350px' }}>
          <input
            type="checkbox"
            id="Below10th"
            checked={educationQualification.includes('Below 10th')}
            onChange={() => handleEducationToggle('Below 10th')}
          />
          <label htmlFor="Below10th">Below 10th</label>

          <input
            type="checkbox"
            id="10thPassandAbove"
            checked={educationQualification.includes('10th Pass and Above')}
            onChange={() => handleEducationToggle('10th Pass and Above')}
          />
          <label htmlFor="10thPassandAbove">10th Pass and Above</label>

          <input
            type="checkbox"
            id="ITI"
            checked={educationQualification.includes('ITI')}
            onChange={() => handleEducationToggle('ITI')}
          />
          <label htmlFor="ITI">ITI</label>

          <input
            type="checkbox"
            id="Diploma"
            checked={educationQualification.includes('Diploma')}
            onChange={() => handleEducationToggle('Diploma')}
          />
          <label htmlFor="Diploma">Diploma</label>

          <input
            type="checkbox"
            id="UG"
            checked={educationQualification.includes('UG')}
            onChange={() => handleEducationToggle('UG')}
          />
          <label htmlFor="UG">UG</label>

          <input
            type="checkbox"
            id="PG"
            checked={educationQualification.includes('PG')}
            onChange={() => handleEducationToggle('PG')}
          />
          <label htmlFor="PG">PG</label>
        </div>
      </div>

      <div className={styles['modal-footer']}>
        <button
          className={styles['confirm-btn']}
          onClick={() => setShowEduQualityPopup(false)}
        >
          Confirm
        </button>
      </div>
    </div>
  </div>
)}

      {/* SAVE POPUP */}
      {showSavePopup && (
        <div className={styles['modal-overlay']}>
          <div className={`${styles['modal-content']} ${styles['save-modal']}`}>
            <h5>Do you want to save the job to publish later?</h5>
            <div className={styles['button-group']}>
              <button className={styles['cancel-btn']} onClick={() => setShowSavePopup(false)}>
                No
              </button>
              <button className={styles['confirm-btn']} onClick={() => setShowSavePopup(false)}>
                Save
              </button>
            </div>
          </div>
        </div>
      )}

      {/* WHATSAPP ALERT POPUP */}
      {showWhatsAppAlert && (
        <div className={styles['modal-overlay']}>
          <div className={`${styles['modal-content']} ${styles['whatsapp-alert-modal']}`}>
            <p>
              Turning off this option will stop the WhatsApp alert service. You will not receive notifications on WhatsApp for candidate responses.
            </p>
            <h6>Are you sure you want to turn off this option?</h6>
            <div className={styles['button-group']}>
              <button className={styles['secondary-btn']} onClick={() => {
                setWhatsappNoti(false);
                setShowWhatsAppAlert(false);
              }}>
                Yes
              </button>
              <button className={styles['primary-btn']} onClick={() => setShowWhatsAppAlert(false)}>
                No
              </button>
            </div>
          </div>
        </div>
      )}

      {/* OTP POPUP */}
      {showOtpPopup && (
        <div className={styles['modal-overlay']}>
          <div className={`${styles['modal-content']} ${styles['otp-modal']}`}>
            {!otpVerified ? (
              <>
                <div className={styles['modal-header']}>
                  <h2>OTP Verification</h2>
                  <button className={styles['close-btn']} onClick={() => setShowOtpPopup(false)}>×</button>
                </div>

                <p className={styles['otp-message']}>
                  Please enter the OTP code sent <br />to <span>+91 {otpFor === 'alternate' ? alternateNum : contactNum}</span>
                </p>

                <div className={styles['otp-inputs']}>
                  {[0, 1, 2, 3, 4, 5].map(index => (
                    <input
                      key={index}
                      type="text"
                      maxLength="1"
                      ref={el => otpInputsRef.current[index] = el}
                      value={otpValues[index]}
                      onChange={(e) => handleOtpChange(index, e.target.value)}
                      onKeyDown={(e) => handleOtpKeyDown(index, e)}
                    />
                  ))}
                </div>

                {showOtpError && <div className={styles['error-message']}>Invalid OTP entered</div>}

                <button
                  className={styles['verify-btn']}
                  onClick={verifyOtp}
                  disabled={otpLoading}
                >
                  {otpLoading ? 'Verifying...' : 'Verify'}
                </button>

                <p className={styles['resend-text']}>
                  Didn't receive an OTP?
                  {otpTimer > 0 ? (
                    <span className={styles['timer']}>Resend in {otpTimer}s</span>
                  ) : (
                    <button className={styles['resend-btn']} onClick={resendOtp}>
                      Resend
                    </button>
                  )}
                </p>
              </>
            ) : (
              <>
                <h2 className={styles['verified-title']}>Mobile Number Verified</h2>
                <div className={styles['verified-image']}>
                  {/* <img src={mobVerified} alt="Verified" /> */}
                </div>
              </>
            )}
          </div>
        </div>
      )}

      {/* PRICING POPUP */}
      {showPricingPopup && (
        <div className={styles.pricing_popupContainer}>
          <div className={styles.pricing_popupBody}>
            <div className={styles.pricing_popupContent}>
              <h2 className={`text-center mb-2`} style={{ fontWeight: 700 }}>Pricing</h2>
              <div className={`d-grid ${styles['justify-content-end']} pe-4 pe-sm-0`} style={{ marginTop: '-50px', marginRight: '-20px' }}>
                <button type="button" className={`btn-close ${styles.pricingPopupCloseBtn}`} onClick={() => setShowPricingPopup(false)}>×</button>
              </div>

              <div>
                {/* <div className={styles.billingBtn} className={`mt-4`}> */}
                <div className={`${styles.billingBtn} mt-4`}>
                  <button className={`text-center ${styles.monthlyPlanBtn} ${styles.activePlanBtn}`}>Bill Monthly</button>
                  <button className={`text-center ${styles.yearlyPlanBtn} ${styles.idlePlanBtn}`}>
                    <p style={{ marginTop: '-5px' }}>Bill yearly</p>
                    <p style={{ fontSize: '10px', marginTop: '-20px', marginBottom: '-20px' }}>Save 50%</p>
                  </button>
                </div>
                <h5 className={`${styles.pricingAlertText} text-center mb-3 mt-3 text-danger`}></h5>
                <div>
                  <p className={`text-center mt-1 ${styles.pricingErrText}`}>
                    Your Taizo Free Trial has Ended. <br /> To continue to post the job you can subscribe to a Monthly / Annual plan that works for you
                  </p>
                </div>
                <div className={styles.monthlyPlanDetails}>
                  <p className={`text-center mx-auto ${styles.saveOffer} d-none`}>save 50%</p>
                  <h4 className={`text-center mt-3`}>
                    <span className={styles.priceVal} style={{ fontSize: 'xx-large' }}>₹999</span>/<span className={styles.planName}>month</span>
                  </h4>
                  <div className={`${styles.startpln} ${styles.startplnyearly} text-center mt-4`}>
                    <a href="#" style={{ textDecoration: 'none' }} className={styles.startplnbtn}>Upgrade</a>
                  </div>
                  <ul className={styles.priceDetList} style={{ marginTop: '20px' }}>
                    <li className={styles.priceDetListItem}><img className={styles.imgPrice} src="/images/invoice_success_icon.png" /><b className={styles.jobCount}>1 Job Post</b></li>
                    <li className={styles.priceDetListItem}><img className={styles.imgPrice} src="/images/invoice_success_icon.png" />Unlimited Candidate Responses</li>
                    <li className={styles.priceDetListItem}><img className={styles.imgPrice} src="/images/invoice_success_icon.png" />Interview Scheduling</li>
                    <li className={styles.priceDetListItem}><img className={styles.imgPrice} src="/images/invoice_success_icon.png" />Pre-screening Questions</li>
                    <li className={styles.priceDetListItem}><img className={styles.imgPrice} src="/images/invoice_success_icon.png" />Email Notifications</li>
                    <li className={styles.priceDetListItem}><img className={styles.imgPrice} src="/images/invoice_success_icon.png" />Push Notifications</li>
                    <li className={styles.priceDetListItem}><img className={styles.imgPrice} src="/images/invoice_success_icon.png" />WhatsApp Notifications</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* LOCATION POPUP */}
      {showLocationPopup && (
        <div className={`${styles.location_popup_wrp} common_popupContainer`}>
          <div className={`common_popup_body`}>
            <div className={`common_popupContent`}>
              <h4>
                <div className={`row`}>
                  <div className={`col-11`}>Please select your location</div>
                  <div className={`col-1`}>
                    <div className={`d-grid ${styles['justify-content-end']} mb-2 ${styles.location_popup_cancel}`}>
                      <div className={styles.closeBtn} onClick={() => setShowLocationPopup(false)}></div>
                    </div>
                  </div>
                </div>
              </h4>
              <p className={styles.map_location_info}>( Location of your company will help job seekers reach you easily for the interview. )</p>
              <div className={styles.seacrch_by_company}>
                <label htmlFor="companyName_gmap">Search for your location</label>
                <input
                  id="companyName_gmap"
                  type="text"
                  className={`${styles['form-control']} ${styles.companyName_gmap} search_icon`}
                  placeholder="Search by Company Name, Area, Location..."
                  style={{
                    backgroundImage: `url(${searchIcon})`,
                    backgroundSize: '20px',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: '97% center'
                  }}
                />
              </div>
              {/* <div className={`${styles.location_btn_wrp} my-3`}>
                <p className={`text-center mt-3 or_divider`} style={{ marginBottom: '0px' }}>or</p>
                <button className={styles.use_cur_location}>
                  <img src={locationIcon} alt="" /> Use current location
                </button>
              </div> */}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PostJobUpdate;